export default {
  partnerLogoCount: 16,
}
